<template>
	<header>
		<div class="container-fluid">
			<div class="row">
				<div class="col">
					<h1>{{title}}</h1>
				</div>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "Header",
	props: {
		title: String
	}
};
</script>
